import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const EraseIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
}) => (
  <SvgWrapper aria-label="Erase Icon" viewBox={viewBox} size={size} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m7.414 7.025-5.06 5.095a.506.506 0 0 0 0 .712l5.06 5.094c.375.378.884.59 1.414.59H21c.552 0 1-.45 1-1.007V7.442c0-.556-.448-1.006-1-1.006H8.828c-.53 0-1.039.212-1.414.59zm10.763 2.609-.354-.356a.498.498 0 0 0-.707 0L15 11.408l-2.116-2.13-.07-.059a.498.498 0 0 0-.637.059l-.354.356-.058.07a.506.506 0 0 0 .058.641l2.117 2.13-2.117 2.131a.506.506 0 0 0 0 .712l.354.356.069.058a.497.497 0 0 0 .638-.058L15 13.543l2.116 2.13.07.06a.497.497 0 0 0 .637-.06l.354-.355.058-.07a.506.506 0 0 0-.058-.642l-2.117-2.13 2.117-2.13.058-.07a.506.506 0 0 0-.058-.642z"
      fill={color}
    />
  </SvgWrapper>
)

export default EraseIcon
